import { render, staticRenderFns } from "./DeleteCampaignGroupModal.vue?vue&type=template&id=244459f4"
import script from "./DeleteCampaignGroupModal.vue?vue&type=script&lang=js"
export * from "./DeleteCampaignGroupModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports